import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

import { PdpRespDealerDetailsReviewsLazy_viewer$key } from './__generated__/PdpRespDealerDetailsReviewsLazy_viewer.graphql';
import { PdpRespDealerDetailsReviewsLazy_seller$key } from './__generated__/PdpRespDealerDetailsReviewsLazy_seller.graphql';

type Props = {
    viewer: PdpRespDealerDetailsReviewsLazy_viewer$key;
    seller: PdpRespDealerDetailsReviewsLazy_seller$key;
};

const PdpRespDealerDetailsReviews = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpRespDealerDetailsReviews" */ './PdpRespDealerDetailsReviews'
        )
);

export const PdpRespDealerDetailsReviewsLazy: FC<Props> = ({
    viewer: viewerRef,
    seller: sellerRef,
}) => {
    const viewer = useFragment(
        graphql`
            fragment PdpRespDealerDetailsReviewsLazy_viewer on Viewer {
                ...PdpRespDealerDetailsReviews_viewer
            }
        `,
        viewerRef
    );
    const seller = useFragment(
        graphql`
            fragment PdpRespDealerDetailsReviewsLazy_seller on Seller {
                ...PdpRespDealerDetailsReviews_seller
            }
        `,
        sellerRef
    );

    return (
        <ClientSuspense fallback={null}>
            <PdpRespDealerDetailsReviews viewer={viewer} seller={seller} />
        </ClientSuspense>
    );
};
